var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 23.3301C18.7802 23.3301 22.25 19.8603 22.25 15.5801C22.25 11.2999 18.7802 7.83008 14.5 7.83008C10.2198 7.83008 6.75 11.2999 6.75 15.5801C6.75 19.8603 10.2198 23.3301 14.5 23.3301Z",
    fill: "#FFC000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6071 24.4964L19.1914 34.9121L29.6071 45.3278L40.0228 34.9121L29.6071 24.4964Z",
    fill: "#0098C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3611 48.8L14.3711 45.69V1L29.3611 4.11002V48.8Z",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39062 48.8L14.3706 45.69V1L1.39062 4.11002V48.8Z",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3594 48.8L42.6094 45.69V1L29.3594 4.11002V48.8Z",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8516 19.3496L38.8616 23.2096",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8616 18.7998L34.8516 24.0798",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5794 16.7202C36.5794 16.7202 36.5194 16.4102 36.3594 15.9502",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9805 12.1995C32.3205 11.9295 31.5405 11.7695 30.6305 11.7695C26.7505 11.7695 24.1405 14.3495 23.8105 20.5995C23.4705 26.8495 21.8705 32.4295 15.4505 32.4295C13.4305 32.4295 11.8805 31.4795 10.7305 30.2695",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1389 25.9699C7.9689 25.4999 7.87891 25.21 7.87891 25.21",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.212abfc513be792b41132cf35918d256.svg";
export { ForwardRef as ReactComponent };